import * as React from 'react';
import { useMemo } from 'react';

import type { Location } from 'history';

import DefaultHeader from 'bundles/composable-page-header-consumer/header-renderers/DefaultHeader';
import SimplifiedHeader from 'bundles/composable-page-header-consumer/header-renderers/SimplifiedHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';

type Props = {
  isSimplified: boolean;
  location?: Location;
};

const PremiumHubPageHeader = ({ isSimplified }: Props) => {
  return useMemo(
    () => (
      <React.Fragment>
        {isSimplified ? (
          <SimplifiedHeader
            enableCourseraLogoLink={false}
            showProgramSwitcher={false}
            showLanguageDropdown={false}
            showAcctDropdown={false}
            showSignupBtn={false}
            showLoginBtn={false}
          />
        ) : (
          <DefaultHeader isPositionStatic />
        )}
        <UniversalPageFeatures />
      </React.Fragment>
    ),
    [isSimplified]
  );
};

export default PremiumHubPageHeader;
